var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
     'background-color': _vm.project && _vm.project.backgroundColor ? _vm.project.backgroundColor : '#000',
   }),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }